// 表单配置 （模块配置表单）
import request from "@/services/axios";
import { url } from "@/services/api";

export default {
  // 分页列表查询
  getModulePage(params) {
    return request({
      url: url + "/system/module/list",
      method: "get",
      params: params
    });
  },
  // 下拉列表查询
  getModuleList(params) {
    return request({
      url: url + "/system/module/selectList",
      method: "get",
      params: params
    });
  },
  // 新增在线表单模块信息
  AddModule(data) {
    return request({
      url: url + "/system/module",
      method: "post",
      data: data
    });
  },
  // 新增在线表单模块信息
  AddBatchModule(data) {
    return request({
      url: url + "/system/module/addBatch",
      method: "post",
      data: data
    });
  },
  // 修改在线表单模块信息
  UpdateModule(data) {
    return request({
      url: url + "/system/module",
      method: "put",
      data: data
    });
  },
  // 删除在线表单模块信息
  DelModule(data) {
    return request({
      url: url + "/system/module/" + data.id,
      method: "delete"
    });
  },
  // 获取在线表单模块信息详细信息
  getModuleInfo(params) {
    return request({
      url: url + "/system/module/" + params.id,
      method: "get"
    });
  },
  // 获取在线表单多表页面模块信息
  getPageModuleInfo(params) {
    return request({
      url: url + "/tool/onl/getDetailInfo/" + params.headId,
      method: "get"
    });
  },
  // 获取在线表单多表详情页数据
  getPageModuleDetail(params) {
    return request({
      url: url + "/tool/onl/getDetailData",
      method: "get",
      params: params
    });
  },
  // 新增在线表单多表详情页数据
  AddPageModuleDetail(data) {
    return request({
      url: url + "/tool/onl/addDetail",
      method: "post",
      data: data
    });
  },
  // 修改在线表单多表详情页数据
  UpdatePageModuleDetail(data) {
    return request({
      url: url + "/tool/onl/updateDetail",
      method: "post",
      data: data
    });
  },
  // 删除在线表单多表详情页子表数据
  DelModuleDetail(data) {
    return request({
      url: url + "/tool/onl/deleteDetail",
      method: "post",
      data: data
    });
  }
};
